import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../dashboard.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-registru-valability',
    templateUrl: './registru-valability.component.html',
    styleUrls: ['./registru-valability.component.scss']
})
export class RegistruValabilityComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;
    form!: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { id_document: number, passedRequestId: number, valability: Date },
        private dialogRef: MatDialogRef<RegistruValabilityComponent>,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private docService: DashboardService,) { }

    ngOnInit(): void {
        this.buildForm();
    }

    buildForm() {
        this.form = this.fb.group({
            valability: [this.data.valability || new Date(), Validators.required],
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    addMonthsToValability(months: number) {
        //const currentDate = this.form.get('valability')?.value || new Date();
        const currentDate = new Date();
        let newDate = new Date(currentDate);

        newDate.setMonth(newDate.getMonth() + months);

        let day = currentDate.getDate();
        while (newDate.getDate() !== day) {
            newDate.setDate(newDate.getDate() - 1);
        }

        this.form.patchValue({
            valability: newDate
        });
    }

    submitRegistruValability() {
        const valabilityData = {
            valability: this.form.get('valability')?.value
        };

        Swal.fire({
            title: this.helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să înregistrați documentul în registru. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: this.helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: this.helper.dialogConfig.colorButtons.standard,
            confirmButtonText: this.helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
            preConfirm: () => {
                return this.docService.addToRegistru(this.data.passedRequestId, this.data.id_document, valabilityData)
                    .pipe(finalize(() => this.isLoading = false))
                    .toPromise();
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.notificationService.warningSwal(
                    this.successTitle,
                    'Document adaugat în registru cu succes!',
                    this.successIcon
                ).then(() => {
                    this.dialogRef?.close({
                        success: true,
                    });
                })
            }
        }).catch((error) => {
            let msg;
            try {
                msg = error.error.errors.message[0];
            } catch (err) {
                msg = this.helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        });
    }

}
